import { useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';
import { MeetingsTab } from '@/features/action-panel/meetings/meetings-tab';

import { useHandleDeleteMeeting } from '../../action-panel/meetings/hooks/use-handle-delete-meeting';
import { useProject } from '../overview/use-project.query';
import { projectIdState } from '../project.state';

import { useProjectMeetings } from './meetings/use-project-meetings.query';
import { useAtomValue } from 'jotai';

export const ProjectMeetingsTab = () => {
  const queryClient = useQueryClient();

  const { data: meetings, isFetching } = useProjectMeetings();
  const projectId = useAtomValue(projectIdState);
  const { data: project } = useProject(projectId);

  const refreshData = async () => {
    await queryClient.invalidateQueries({
      queryKey: [QueryKey.ProjectMeetings, projectId],
    });
  };

  const { onDeleteHandler, isDeleting } = useHandleDeleteMeeting({
    onRefreshData: refreshData,
  });

  if (!project) return null;

  return (
    <MeetingsTab
      meetingsData={meetings ?? []}
      refreshHandler={refreshData}
      isLoading={isFetching || isDeleting}
      deleteMeetingHandler={onDeleteHandler}
      newMeetingFormDefaultValues={{
        relatedProjectId: project.id,
        relatedTeamId: project.team ? project.team.id : undefined,
      }}
      withCompanyField
      context="project"
    />
  );
};
